import { DmsDocumentEntityBuilder } from 'apps/idl/src/modules/dms/model/DmsDocumentEntityBuilder';
import { C_PREFIX_ORDONNANCE } from '../../../app/app.constants';

export class OrdonnanceEntityBuilder extends DmsDocumentEntityBuilder {
	constructor() {
		super();
		this.match = (psModelId: string) => psModelId.startsWith(C_PREFIX_ORDONNANCE);
		this.category = () => "Ordonnances";
	}
}